import {usePathname, useRouter, useSearchParams} from "next/navigation";


export default function useRedirectToLogin(url = "/login") {
    const router = useRouter();

    return (successUrl?: string) => {
        if (typeof window === "undefined") return;

        const currentPath = window.location.pathname + window.location.search;
        const finalSuccess = successUrl || currentPath;

        let failUrl: string;

        if (currentPath.includes("user") || currentPath.includes("admin")) {
            failUrl = "/";
        } else {
            failUrl = currentPath;
        }

        sessionStorage.setItem("successAfterLogin", finalSuccess);

        const redirectUrl =
            `${url}?successUrl=${encodeURIComponent(finalSuccess)}&failUrl=${encodeURIComponent(failUrl)}`;

        router.push(redirectUrl);
    };
}


export function useRedirectBetweenEnterPages() {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    return (path: string, extraQuery?: { [key: string]: any }) => {
        if (typeof window === "undefined") return;

        const failUrl = `${pathname}?${searchParams.toString()}`;
        const successUrl = searchParams.get("successUrl") || "/";

        const queryParams = new URLSearchParams({successUrl, failUrl});

        if (extraQuery) {
            Object.entries(extraQuery).forEach(([key, value]) => {
                queryParams.set(key, String(value));
            });
        }

        const redirectUrl = `${path}?${queryParams.toString()}`;
        router.push(redirectUrl);
    };
}
